import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { BundlerIcon, InsiderIcon, SniperIcon } from '@root/shared/ui-kit'

import { PairSnipersBundlersInsidersTooltipBodyItem } from './pair-snipers-bundlers-insiders-tooltip-body-item'

import type { BigNumber } from 'bignumber.js'

type Item = 'snipers' | 'insiders' | 'bundlers'

type Props = {
  bundlersHolding: BigNumber | undefined
  snipersHolding: BigNumber | undefined
  insidersHolding: BigNumber | undefined
  order?: ReadonlyArray<Item>
}

const defaultOrder: Array<Item> = ['snipers', 'insiders', 'bundlers']

export const PairSnipersBundlersInsidersTooltipBody = ({
  bundlersHolding,
  snipersHolding,
  insidersHolding,
  order = defaultOrder,
}: Props) => {
  const { t } = useTranslation()

  const renderItem = (item: Item) => {
    return match(item)
      .with('bundlers', () =>
        bundlersHolding ? (
          <PairSnipersBundlersInsidersTooltipBodyItem
            key={item}
            holding={bundlersHolding}
            label={t('bundlers')}
            icon={BundlerIcon}
          />
        ) : undefined,
      )
      .with('snipers', () =>
        snipersHolding ? (
          <PairSnipersBundlersInsidersTooltipBodyItem
            key={item}
            holding={snipersHolding}
            label={t('trading.audit.snipers')}
            icon={SniperIcon}
          />
        ) : undefined,
      )
      .with('insiders', () =>
        insidersHolding ? (
          <PairSnipersBundlersInsidersTooltipBodyItem
            key={item}
            holding={insidersHolding}
            label={t('insiders')}
            icon={InsiderIcon}
          />
        ) : undefined,
      )
      .exhaustive()
  }

  const items = order.map(renderItem).filter(Boolean)

  return <TooltipContentRoot>{items}</TooltipContentRoot>
}

const TooltipContentRoot = styled.div`
  min-width: 140px;
  display: grid;
  gap: 4px;
`
